<div class="modal fade get-insights-modal logistics-bulk-modal logistics-insights-modal" [id]="modalId" tabindex="-1" role="dialog"
     aria-labelledby="get-insights-title" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-heading">
          <span class="insights-mark" aria-hidden="true"><i class="far fa-sparkle"></i></span>
          <div>
            <h5 class="modal-title" id="get-insights-title">Get insights</h5>
            <p class="modal-context">
              {{ selectedCompanyCount | number }} {{ selectedCompanyCount === 1 ? 'selected company' : 'selected companies' }}
            </p>
          </div>
        </div>
        <button type="button" class="close-button" data-dismiss="modal" aria-label="Close">
          <i class="far fa-times" aria-hidden="true"></i>
        </button>
      </div>

      <div class="modal-body">
        @if (!showModulePicker && selectedModule) {
          <div class="section-label">Insight</div>
          <div class="selected-insight-summary">
            <span class="selected-insight-icon"><i [class]="selectedModule.isOrganisationModule ? 'far fa-flask' : 'far fa-bolt'"></i></span>
            <span class="module-copy">
              <strong>{{ displayModuleName(selectedModule) }}</strong>
              <small>{{ selectedModule.isOrganisationModule ? 'Custom research · organisation questions' : 'Ready-made · existing Zint research' }}</small>
            </span>
            <button type="button" class="change-insight-button" (click)="showModulePicker = true">Change</button>
          </div>
        } @else {
          <div class="section-label">Choose one insight</div>
          <div class="module-picker" role="radiogroup" aria-label="Magic Insights module">
            @if (hasReadyMadeModules) {
              <div class="module-category">
                <strong><i class="far fa-bolt category-icon ready-icon" aria-hidden="true"></i>Ready-made insights</strong>
                <span>Existing Zint research</span>
              </div>
              @for (module of modulesInfo; track module.id) {
                @if (!module.isOrganisationModule) {
                  <label class="module-row" [class.is-selected]="selectedModuleId === module.id">
                    <input type="radio" name="getInsightsModule" [value]="module.id"
                           [(ngModel)]="selectedModuleId" (ngModelChange)="moduleChanged()">
                    <span class="module-selection" aria-hidden="true">
                      @if (selectedModuleId === module.id) { <i class="fas fa-check"></i> }
                    </span>
                    <span class="module-copy">
                      <strong>{{ displayModuleName(module) }}</strong>
                    </span>
                  </label>
                }
              }
            }

            @if (hasCustomModules) {
              <div class="module-category custom-category">
                <strong><i class="far fa-flask category-icon custom-icon" aria-hidden="true"></i>Custom research</strong>
                <span>Your organisation's questions</span>
              </div>
              @for (module of modulesInfo; track module.id) {
                @if (module.isOrganisationModule) {
                  <label class="module-row" [class.is-selected]="selectedModuleId === module.id">
                    <input type="radio" name="getInsightsModule" [value]="module.id"
                           [(ngModel)]="selectedModuleId" (ngModelChange)="moduleChanged()">
                    <span class="module-selection" aria-hidden="true">
                      @if (selectedModuleId === module.id) { <i class="fas fa-check"></i> }
                    </span>
                    <span class="module-copy">
                      <strong>{{ displayModuleName(module) }}</strong>
                      @if (module.questionCount) {
                        <small>{{ module.questionCount | number }} {{ module.questionCount === 1 ? 'question' : 'questions' }} per company</small>
                      }
                    </span>
                  </label>
                }
              }
            }
          </div>
        }

        @if (canEditCompanyCount) {
          <div class="company-limit-group">
            <label class="section-label" for="get-insights-limit">Companies to include</label>
            <input id="get-insights-limit" type="number" min="1" [max]="maximumCompanies" class="form-control"
                   [ngModel]="selectedCompanyLimit" (ngModelChange)="onCompanyLimitChange($event)"
                   placeholder="Use the full search audience">
            <p class="field-help">Follows your current sort order. Maximum {{ maximumCompanies | number }}.</p>
            @if (isSelectionTooLarge) {
              <p class="inline-validation">Enter between 1 and {{ maximumCompanies | number }} companies.</p>
            }
          </div>
        }

        <div class="calculation-area" aria-live="polite">
          @if (selectedModule && (isCalculating || isAwaitingRecalculation)) {
            <div class="calculation-state">
              <zint-loader size="xSmall"></zint-loader>
              <span>Checking availability and credits...</span>
            </div>
          }

          @if (selectedModule && creditCalculation && hasActionableResults) {
            <div class="summary-panel">
              @if (selectedModule.isOrganisationModule) {
                <div class="outcome-row">
                  <i class="far fa-clock outcome-icon custom-icon"></i>
                  <strong>{{ creditCalculation.custom_research_answer_count | number }} custom answers</strong>
                  <span>{{ shortTimingLabel }}</span>
                </div>
              } @else {
                <div class="outcome-row">
                  <i class="far fa-bolt outcome-icon ready-icon"></i>
                  <strong>{{ creditCalculation.ready_made_company_count | number }} ready-made results</strong>
                  <span>Available now</span>
                </div>
              }
              @if (creditCalculation.already_available_count) {
                <div class="outcome-row">
                  <i class="far fa-check-circle outcome-icon available-icon"></i>
                  <strong>{{ creditCalculation.already_available_count | number }} already accessible</strong>
                  <span>No credits used</span>
                </div>
              }
              @if (creditCalculation.unavailable_company_count) {
                <div class="outcome-row">
                  <i class="far fa-info-circle outcome-icon unavailable-icon"></i>
                  <strong>{{ creditCalculation.unavailable_company_count | number }} unavailable</strong>
                  <span>Skipped automatically</span>
                </div>
              }

              <div class="credit-costs">
                <div class="credit-line">
                  <span>Cost</span>
                  <strong>{{ maximumCreditCost | number }} {{ maximumCreditCost === 1 ? 'credit' : 'credits' }}</strong>
                </div>
                <div class="credit-line">
                  <span>Balance after</span>
                  @if (creditCalculation.has_enough_credits) {
                    <strong>{{ projectedCreditBalance | number }} of {{ creditCalculation.credits_remaining | number }} credits</strong>
                  } @else {
                    <strong>{{ creditCalculation.credits_remaining | number }} credits available</strong>
                  }
                </div>
              </div>
            </div>
          }

          @if (selectedModule && creditCalculation && !hasActionableResults) {
            <div class="empty-state">
              <span class="empty-state-icon"><i class="far fa-sparkle"></i></span>
              <div>
                <strong>No new insights available for this selection</strong>
                <p>{{ creditCalculation.unavailable_company_count | number }} {{ creditCalculation.unavailable_company_count === 1 ? 'company cannot' : 'companies cannot' }} currently be processed for {{ displayModuleName(selectedModule) }}. Try another insight or change your selection.</p>
              </div>
            </div>
          }

          @if (creditCalculation && hasActionableResults && !creditCalculation.has_enough_credits) {
            <p class="limit-warning">
              <i class="far fa-exclamation-circle" aria-hidden="true"></i>You need {{ creditCalculation.credits_required | number }} credits but have
              {{ creditCalculation.credits_remaining | number }} remaining.
            </p>
          }
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="cancel-button" data-dismiss="modal">Cancel</button>
        <button type="button" class="submit-button" [disabled]="!canSubmit" (click)="submit()">
          @if (isSubmitting) {
            <i class="fas fa-spinner fa-spin"></i>Submitting...
          } @else {
            <i class="far fa-sparkle"></i>{{ submitButtonLabel }}
          }
        </button>
      </div>
    </div>
  </div>
</div>
